
import { Options, mixins } from "vue-class-component";
import UtilityOptions from "../../mixins/UtilityOptions";

@Options({
  title: 'Report',
  components: {},
})

export default class Report extends mixins(UtilityOptions) {
  private home = { icon: "pi pi-home", to: "/" };
  private items = [{ label: "Report" }];
  private reportList = [
    {
      label: "User Report",
      permission: "user_report",
      image: require("@/assets/menu-icons/reports/user_report.png").default,
      to: "/report/user-report",
      description:"",
    },
    {
      label: "Sales Report",
      permission: "sales_report",
      image: require("@/assets/menu-icons/reports/sales_refund_report.png").default,
      to: "/report/sales-report",
      description:"",
    },
    {
      label: "Sales-Refund Report",
      permission: "sales_refund_report",
      image: require("@/assets/menu-icons/reports/sales_refund_report.png").default,
      to: "/report/sales-refund-report",
      description:"",
    },
    {
      label: "Stock Alert Report",
      permission: "stock_alert_report",
      image: require("@/assets/menu-icons/reports/alert.png").default,
      to: "/report/stock-alert-report",
      description:"",
     },
    {
      label: "Purchasing Report",
      permission: "purchasing_report",
      image: require("@/assets/menu-icons/reports/purchasing.png").default,
      to: "/report/purchasing-report",
      description:"",
    },
    {
      label: "Purchase Returns Report",
      permission: "purchase_returns_report",
      image: require("@/assets/menu-icons/reports/purchasing.png").default,
      to: "/report/purchase-return-report",
      description:"",
    },
    {
      label: "Transfer Stock Report",
      permission: "transfer_stock_report",
      image: require("@/assets/menu-icons/reports/stock_transfer.png").default,
      to: "/report/transfer-reports",
      description:"",
    },
    {
      label: "Performance Report",
      permission: "performance_report_old",
      image: require("@/assets/menu-icons/reports/performance.png").default,
      to: "/report/performance-report",
      description:"",
    },
    {
      label: "General Journal",
      permission: "general_journal_old",
      image: require("@/assets/menu-icons/reports/general.png").default,
      to: "/report/general-journal-report",
      description:"",
    },
    {
      label: "Income Statement",
      permission: "income_statement_old",
      image: require("@/assets/menu-icons/reports/income.png").default,
      to: "/report/income-statement-report",
      description:"",
    },
    
    {
      label: "Trial Balance",
      permission: "trial_balance_old",
      image: require("@/assets/menu-icons/reports/trail_balance.png").default,
      to: "/report/trial-balance-report",
      description:"",
    },
    {
      label: "Ledger Statement",
      permission: "ledger_statement_old",
      image: require("@/assets/menu-icons/reports/ledger.png").default,
      to: "/report/ledger-statement",
      description:"",
    },
    {
      label: "Tax Report",
      permission: "tax_report_old",
      image: require("@/assets/menu-icons/reports/tax.png").default,
      to: "/report/tax-report",
      description:"",
    },
     {
      label: "Stock Report",
      permission: "stock_report",
      image: require("@/assets/menu-icons/reports/stock.png").default,
      to: "/report/stock-report",
      description:"",
    },
    {
      label: "Stock Expiry Report",
      permission: "stock_expiry_report",
      image: require("@/assets/menu-icons/reports/expiry.png").default,
      to: "/report/expiry-report",
      description:"",
    },
    {
      label: "Upcomming Expiry Report",
      permission: "stock_near_expiry_report",
      image: require("@/assets/menu-icons/dashboard/near_expiry.png").default,
      to: "/report/near-expiry-report",
      description:"",
    },
    // {
    //   label: "Activity Report",
    //   image: require("@/assets/menu-icons/reports/activity.png").default,
    //   to: "/report/activity-report",
    //   description:"",
    // },
    // {
    //   label: "Bank Reconciliation",
    //   image: require("@/assets/menu-icons/reports/bank.png").default,
    //   to: "/report/bank-reconciliation",
    //   description:"",
    // },
    // {
    //   label: "Account Statement",
    //   image: require("@/assets/menu-icons/reports/account_statement.png").default,
    //   to: "/report/account-statement",
    //   description:"",
    // },
  ];
}
